<template>
  <div id="about">
    <div class="mr-about">
      <div class="mr-about__inner">
        <div class="mr-about__inner__info">
          <div class="mr-about__inner__info__inner">
            <div class="mr-about__inner__info__top">
              <h1>Exploring Mediterranean Futures</h1>
              <p>
                Stegi Radio is an international online radio station based in Athens. It explores
                the cross-cultural interactions, political and theoretical discourses and
                reflections of movement of people from the Mediterranean and beyond, through a
                series of commissioned pieces, thematic mixtapes, interviews, DJ sets and more.
              </p>
              <div class="sub-title">
                Send your mixtape demos at
                <a href="mailto: info@stegi.radio">info@stegi.radio</a>
              </div>
            </div>
            <div class="mr-about__inner__info__bottom">
              <h3>Movement Team</h3>
              <p>
                <strong> Artistic Direction </strong> - Voltnoi & Quetempo <br />
                <strong> Program Advisor </strong> - Marina Gioti<br />
                <strong> Digital Strategy </strong> - Takis Zontiros<br />
                <strong> Radio Manager </strong> - Nikki Georgiou<br />
                <strong> Content Editor </strong> - Yannis Galiatsos<br />
                <strong> Audio Content Manager </strong> - Stefanos Konstantinidis<br />
                <strong> Visual Communication </strong> - NMR.CC<br />
                <strong> Web Development </strong> - GENDY<br />
                <strong> Producer </strong> - Vassilis Panagiotakopoulos<br />
              </p>
              <div class="onassis-section">
                <p>stegi.radio is produced by Onassis Stegi</p>
                <a href="https://www.onassis.org/" target="_blank"><img :src="onassisImage" alt="onassis" /> </a>
              </div>
              <div class="sae-section">
                <p>In collaboration</p>
                <a href="https://www.sae.edu/grc/" target="_blank"><img :src="saeImage" alt="sae" /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="mr-about__inner__image">
          <picture>
            <img :src="aboutImage" alt="MovementRadio About" />
          </picture>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import aboutImage from '@/assets/images/about.jpg';
import onassisImage from '@/assets/logos/onassis-stegi-official-black-inline.svg';
import saeImage from '@/assets/logos/sae.svg';
export default {
  name: 'About',
  data: () => ({
    aboutImage: aboutImage,
    onassisImage: onassisImage,
    saeImage: saeImage
  })
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/pages/_about.scss';
</style>
